<style scoped>
.btn_shadow_half {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 2px 2px 5px #838383, -2px -2px 5px #ffffff !important;
}

.headline {
  background-color: #1b2643;
  width: 100%;
  height: 60px;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.active_text {
  border-bottom: 2px solid #ffffff;
  height: 60px;
}

.headline p {
  color: #ffffff;
  font-size: 14px;
}

td {
  border-bottom: 1px solid #dbdbdb;
}

.color-red {
  color: red;
}
</style>

<template>
  <div>
    <div>
      <div class="pa-3 headline">
        <p class="active_text">{{ $t('interviewDataSearch.searchInterviewData') }}</p>
      </div>

      <!-- 「テストを絞り込む」画面 -->
      <div class="content px-10">
        <v-form ref="form" lazy-validation @submit.prevent>
          <v-row v-show="isFilterTest" class="ml-1 mt-10 mb-n8">
            <p
              class="text-body-2"
              v-html="
                $t('interviewDataSearch.searchExamineeResultByCouponCode')
              "
            ></p>
          </v-row>
          <v-row v-show="isFilterTest" class="mb-2">
            <v-col cols="8">
              <v-text-field
                v-model="filterCouponCode"
                append-icon="mdi-magnify"
                :label="$t('interviewDataSearch.couponCode')"
                single-line
                hide-details
                @keypress.enter="searchCoupon(filterCouponCode)"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                class="ma-2 mb-5 btn_shadow_half"
                color="#1b2643"
                dark
                @click="searchCoupon(filterCouponCode)"
              >
                {{ $t('interviewDataSearch.search') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>

    <loading-circle
      :isLoading="isLoading"
      :text="loadingText"
      :progressValue="couponProgressValue"
    />

    <!-- 「検索結果一覧」画面 -->
    <div v-show="searchedCoupons.length !== 0">
      <div class="content pa-10" >
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>{{ $t('interviewDataSearch.couponCode') }}</th>
                      <th
                        class="text-left"
                        v-html="$t('interviewDataSearch.campaignCodeOrName')"
                      ></th>
                      <th
                        class="text-left"
                        v-html="$t('interviewDataSearch.learnersNameOrmail')"
                      ></th>
                      <th v-html="$t('interviewDataSearch.cefrLevel')"></th>
                      <!-- <th>受験結果</th> -->
                      <th
                        class="text-left"
                        v-html="$t('interviewDataSearch.interviewCounts')"
                      ></th>
                      <th
                        class="text-left"
                        v-html="$t('interviewDataSearch.allowRetakes')"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="searchedCoupon in searchedCoupons"
                      :key="searchedCoupon.id"
                    >
                      <td>
                        {{ searchedCoupon.couponCode }}
                      </td>
                      <td>
                        {{ searchedCoupon.campaignCode }}<br />
                        ({{ searchedCoupon.campaignName }})
                      </td>
                      <td>
                        {{ searchedCoupon.learnerName }}
                        <template v-if="searchedCoupon.learnerMail"
                          ><br />{{ searchedCoupon.learnerMail }}</template
                        >
                      </td>
                      <td>
                        {{ searchedCoupon.cefrLevel }}<br />
                        ({{ searchedCoupon.cefrScore }})
                      </td>
                      <td>
                        <span v-if="!searchedCoupon.ticket.countIsUndefined">
                          {{ searchedCoupon.ticket.count }}
                        </span>
                        <span v-if="searchedCoupon.ticket.countIsUndefined">
                          -
                        </span>
                        <span>/</span>
                        <span>{{ searchedCoupon.limits }}</span>
                      </td>
                      <td>
                        <template>
                          <v-btn
                            class="mr-4 white--text btn_shadow_half"
                            color="#1b2643"
                            @click="resumeBtn(searchedCoupon)"
                            :disabled="checkDisabledRetry(searchedCoupon)"
                          >
                            {{ $t('interviewDataSearch.retakes') }}
                          </v-btn>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-dialog v-model="dialogConfirm" width="600px">
              <v-card class="pt-5">
                <v-card-title class="justify-center">{{
                  $t('interviewDataSearch.dialog.allowRetakeExamPrompt')
                }}</v-card-title>
                <v-card-text>
                  {{ $t('interviewDataSearch.dialog.couponCode') }}
                  {{ editeingItem.couponCode }}<br />
                  {{ $t('interviewDataSearch.dialog.campaignCode') }}
                  {{ editeingItem.campaignCode }}<br />
                  {{ $t('interviewDataSearch.dialog.campaignNam') }}
                  {{ editeingItem.campaignName }}<br />
                  {{ $t('interviewDataSearch.dialog.learnersName') }}
                  {{ editeingItem.learnerName }}<br />
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn color="#1b2643" text @click="dialogConfirm = false">{{
                    $t('interviewDataSearch.dialog.cancle')
                  }}</v-btn>
                  <v-btn color="#1b2643" text @click="resume()">{{
                    $t('interviewDataSearch.retakes')
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-form>
      </div>
    </div>
    <snack-bar
      :snackbarAction="isSnackbarAction"
      :snackbarText="snackbarText"
      :snackbarColor="snackbarColor"
      @closeSnackbar="closeSnackbar"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { campaignService } from "@/api/campaignService";
import { dialogService } from "@/api/dialogService";
import { learnerTicketService } from "@/api/learnerTicketService";
import LoadingCircle from "@/components/Dashboard/PageViewItems/LoadingCircleComponent.vue";
import SnackBar from "@/components/Dashboard/PageViewItems/SnackbarComponent.vue";
import type { DateOrTimestamp } from "@/resources/utils";
import store from "@/store";
import {
  getLearnersByIds,
  getLearnerTicketFromCouponCode,
  invalidateLearnerTicketCache,
} from "@/utils/learnersUtils";

const SYNTHETIC_EMAIL_REGEX = /^learner_.+@learners\.equ\.ai$/;

type CampaignType = {
  documentId: string;
  customerCode: string;
  customerId: string;
  campaignId: string;
  campaignCode: string;
  campaignName: string;
  isUnlimited: boolean;
  limits: number;
  endAt: DateOrTimestamp | null;
};

type TicketInfoType = {
  documentId: string;
  confirmedAt: number;
  countIsUndefined: boolean;
  count: number;
  couponCode: string;
  isAvailable: boolean;
  password: string;
  punchedAt: number | null;
};

type SearchedCouponsType = {
  id: number;
  learnerId: string;
  campaignId: string;
  campaignCode: string;
  campaignName: string;
  ticket: TicketInfoType;
  isUnlimited: boolean;
  limits: string;
  couponCode: string | null;
  learnerMail: string;
  learnerName: string;
  cefrScore: number;
  cefrLevel: string;
  endAt: DateOrTimestamp | null;
};

export default defineComponent({
  name: "LearnersView",
  components: {
    SnackBar,
    LoadingCircle,
  },
  data() {
    return {
      isFilterTest: true,
      couponProgressValue: 0,

      filterCouponCode: "",
      dialogConfirm: false,

      editingIndex: -1,
      editeingItem: {} as SearchedCouponsType,
      campaigns: [] as CampaignType[],
      searchedCoupons: [] as SearchedCouponsType[],

      isSnackbarAction: false,
      snackbarText: this.$t(
        "interviewDataSearch.learnerDataUpdatedMessage",
      ) as string,
      snackbarColor: "pink",

      isLoading: false,
      loadingText: this.$t(
        "interviewDataSearch.progress.longOperationWaitMessage",
      ) as string,
    };
  },

  async mounted() {
    // this.readData()
    this.getCampaigns();
  },

  methods: {
    // snackbarコンポーネントのcloseSnackbar関数
    closeSnackbar() {
      this.isSnackbarAction = false;
    },

    async getCampaigns() {
      const customerId = store.state.customerId || "";
      try {
        const campaigns = await campaignService.list({ cu: customerId });
        this.campaigns = campaigns.map((campaign) => ({
          documentId: campaign.id,
          customerId: campaign.customerId,
          customerCode: campaign.customerCode,
          campaignId: campaign.id,
          campaignCode: campaign.campaignCode,
          campaignName: campaign.name,
          isUnlimited: campaign.isUnlimited,
          limits: campaign.limits,
          endAt: campaign.endAt,
        }));
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      }
    },

    // 検索ボタンを押した際の処理
    async searchCoupon(filterCouponCode: string) {
      this.isLoading = true;
      this.searchedCoupons = [];

      try {
        this.couponProgressValue = 0;
        this.loadingText = this.$t(
          "interviewDataSearch.progress.fetchingDataMessage",
        ) as string;

        const dialogs = await dialogService.list({
          co: filterCouponCode,
          cu: store.getters.customerId,
          isAssessed: true,
        });

        this.loadingText = this.$t(
          "interviewDataSearch.progress.displayingSearchResultsMessage",
        ) as string;

        const learnerIds = dialogs
          .map((dialog) => dialog.learnerId)
          .filter((id): id is string => Boolean(id));

        const learners = await getLearnersByIds(learnerIds);

        const learnerMap = new Map(
          learners.map((learner) => [learner.id, learner]),
        );

        for (const dialog of dialogs) {
          const learnerId = dialog.learnerId;
          const learner = learnerMap.get(learnerId);

          const learnerEmail =
            learner?.email && !SYNTHETIC_EMAIL_REGEX.test(learner.email)
              ? learner.email
              : "";
          const learnerName = learner?.displayName || "";

          const campaignData = this.campaigns.find(
            (item) =>
              item.documentId === dialog.campaignIdLegacy ||
              item.campaignId === dialog.campaignIdLegacy,
          );

          if (!campaignData) {
            this.couponProgressValue = Math.floor(
              ((dialogs.indexOf(dialog) + 1) / dialogs.length) * 100,
            );
            continue;
          }

          let campaignLimit =
            campaignData.isUnlimited === undefined
              ? "-"
              : campaignData.isUnlimited
                ? "無制限"
                : String(campaignData.limits);

          const matchingTicket = await getLearnerTicketFromCouponCode(
            learnerId,
            filterCouponCode,
            campaignData.campaignId,
          );

          if (!matchingTicket) {
            this.couponProgressValue = Math.floor(
              ((dialogs.indexOf(dialog) + 1) / dialogs.length) * 100,
            );
            continue;
          }

          const ticketInfo = {
            documentId: matchingTicket.id,
            confirmedAt: matchingTicket.customerOptions.confirmedAt,
            countIsUndefined:
              matchingTicket.customerOptions.count === undefined,
            count: matchingTicket.customerOptions.count || 0,
            couponCode: matchingTicket.customerOptions.couponCode,
            isAvailable: matchingTicket.customerOptions.isAvailable,
            password: matchingTicket.customerOptions.password,
            punchedAt: matchingTicket.customerOptions.punchedAt,
          };

          this.searchedCoupons.push({
            id: this.searchedCoupons.length,
            learnerId,
            campaignId: campaignData.campaignId,
            campaignCode: campaignData.campaignCode,
            campaignName: campaignData.campaignName,
            ticket: ticketInfo,
            isUnlimited: campaignData.isUnlimited,
            limits: campaignLimit,
            couponCode: ticketInfo.couponCode,
            learnerMail: learnerEmail,
            learnerName: learnerName,
            cefrScore:
              dialog.assessment?.assessmentData?.cefrResults?.overall?.score ||
              0,
            cefrLevel:
              dialog.assessment?.assessmentData?.cefrResults?.overall
                ?.cefrLevel ||
              dialog.assessment?.assessmentData?.cefrResults?.overall?.label ||
              "",
            endAt: campaignData.endAt,
          });
          // Update progress after processing each dialog
          this.couponProgressValue = Math.floor(
            ((dialogs.indexOf(dialog) + 1) / dialogs.length) * 100,
          );
        }
      } catch (error) {
        console.error("Error searching for coupon:", error);
        // Handle the error appropriately
      } finally {
        this.loadingText = this.$t(
          "interviewDataSearch.progress.longOperationWaitMessage",
        ) as string;
        this.couponProgressValue = 0;
        this.isLoading = false;
      }
    },

    // 再受験ボタン
    resumeBtn(resumeCoupon: SearchedCouponsType) {
      this.dialogConfirm = !this.dialogConfirm;
      this.editingIndex = this.searchedCoupons.indexOf(resumeCoupon);
      this.editeingItem = resumeCoupon;
    },

    checkDisabledRetry(searchedCoupon: SearchedCouponsType) {
      const currentTime = Math.floor(Date.now() / 1000);
      return (
        searchedCoupon.ticket.count !== Number(searchedCoupon.limits) ||
        searchedCoupon.endAt === null ||
        Number(searchedCoupon.endAt) <= currentTime
      );
    },

    // 再受験機能
    async resume() {
      this.dialogConfirm = false;
      const learnerId = this.editeingItem.learnerId;
      const ticket = this.editeingItem.ticket;
      const newCount = ticket.count - 1;
      invalidateLearnerTicketCache(
        learnerId,
        ticket.couponCode,
        this.editeingItem.campaignId,
      );
      const success = await learnerTicketService.updateById(
        learnerId,
        ticket.documentId,
        { count: newCount },
      );
      if (!success) {
        this.isSnackbarAction = true;
        this.snackbarText = this.$t(
          "interviewDataSearch.retakeErrorMessage",
        ) as string;
        this.snackbarColor = "red";
        return;
      }
      const targetDocumentId = ticket.documentId;
      this.searchedCoupons.forEach((coupon) => {
        if (coupon.ticket.documentId === targetDocumentId) {
          coupon.ticket.count = newCount;
        }
      });
      this.isSnackbarAction = true;
      this.snackbarText = this.$t(
        "interviewDataSearch.retestConfigurationCompletedMessage",
      ) as string;
      this.snackbarColor = "pink";
    },
  },
});
</script>
